// Helper functions for ease of changing configuration later
export type ShiftWithShiftCenter = {
  addressCoordinates: string,
  useShiftCenterDriveTimes: boolean,
  shiftCenter: { addressCoordinates: string | null } | null,
};

export const getShiftStartEndLocation = (
  provider: {addressCoordinates?: string | null},
  shift: ShiftWithShiftCenter
): string => {
  return (shift.useShiftCenterDriveTimes) ?
    (shift.shiftCenter?.addressCoordinates || shift.addressCoordinates)
  :
    (provider?.addressCoordinates || shift.addressCoordinates);
}

export const getVirtualLocation = (provider: {addressCoordinates?: string | null}, shift: ShiftWithShiftCenter): string => {
  return getShiftStartEndLocation(provider, shift)
}

export type VisitResourceForLocation = {
  addressCoordinates?: string | null,
  visit?: {addressCoordinates: string} | null,
  resourceRequirement?: {inHome: boolean} | null
} | null

export const getVisitResourceLocation = (
  resource: VisitResourceForLocation,
  provider: {addressCoordinates?: string | null},
  shift: ShiftWithShiftCenter
): string => {
  if (resource?.addressCoordinates) return resource.addressCoordinates
  const virtualLocation = getVirtualLocation(provider, shift)
  if (!resource || !resource.visit) return virtualLocation
  // assume inHome=true if resource requirement is missing  
  if (!resource.resourceRequirement) return resource.visit.addressCoordinates
  return resource.resourceRequirement.inHome ? resource.visit.addressCoordinates : virtualLocation
}

export function calculateDistanceFt(lat1: number, lon1: number, lat2: number, lon2: number) {
  const R = 20_902_231; // Avg radius of the Earth in feet
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
}

function toRadians(degrees: number) {
  return degrees * (Math.PI / 180);
}
